import { useEffect } from 'react'
import { makePaymentsGetRequest } from 'utils/api'
import { setModules, getModules } from 'utils/paymentService'
import isEmpty from 'lodash/isEmpty'

const withHasModules = Component => {
  function ComponentWithHasModules() {
    const modules = getModules()
    useEffect(() => {
      if (!isEmpty(modules)) return
      ;(async () => {
        const modules = await makePaymentsGetRequest('/v1/customers/modules')
        setModules(modules)
      })()
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Component />
  }

  return ComponentWithHasModules
}

export default withHasModules
